module.exports = __webpack_public_path__ + "img/9788994475042.781be109.jpg";